import { render, staticRenderFns } from "./demandHome.vue?vue&type=template&id=4a24544e&scoped=true"
import script from "./demandHome.vue?vue&type=script&lang=js"
export * from "./demandHome.vue?vue&type=script&lang=js"
import style0 from "./demandHome.vue?vue&type=style&index=0&id=4a24544e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a24544e",
  null
  
)

export default component.exports